module.exports = __webpack_public_path__ + "static/img/fond-modal.e11f88b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fond-modal.jpg
// module id = gIXy
// module chunks = 1